import { useStaticQuery, graphql } from "gatsby"

export const useCarnetAdresse = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allNodeCarnetDAdresse(
          sort: { fields: field_ordre_carnet_d_adresse, order: DESC }
          filter: { field_mise_en_avant: { eq: true } }
        ) {
          ...AllCarnetAdresse
        }
        taxonomyTermZoneDefinie(name: { eq: "carnet_d_adresse" }) {
          ...AllCarnetTaxo
        }
      }
    `
  )
  return data
}

export const queryCarnet = graphql`
  fragment AllCarnetAdresse on node__carnet_d_adresseConnection {
    edges {
      node {
        drupal_internal__nid
        title
        drupal_id
        path {
          alias
        }
        field_adresse {
          address_line1
          address_line2
          postal_code
          locality
        }
        field_mail
        field_ordre_carnet_d_adresse
        field_telephone
      }
    }
  }
`

export const queryTaxo = graphql`
  fragment AllCarnetTaxo on taxonomy_term__zone_definie {
    drupal_internal__tid
    field_label
    description {
      processed
    }
  }
`
